import React from "react";

import CostCategoriesList from "components/BudgetBuilder/BudgetSettings/CostCategoriesList";
import SubawardCostCapAmount from "components/BudgetBuilder/BudgetSettings/SubawardCostCapAmount";
import { TenantFormatterWrapper } from "components/BudgetBuilder/shared/TenantFormatter";

const BudgetSettingsMainView = () => (
	<TenantFormatterWrapper>
		<SubawardCostCapAmount />
		<CostCategoriesList />
	</TenantFormatterWrapper>
);

export default BudgetSettingsMainView;
